/*!

=========================================================
* Vue Argon Design System - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system/blob/master/LICENSE.md)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

const config = require('../config');
window.config = config;
import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import store from './store';
import Argon from "./plugins/argon-kit";
import axios from 'axios'
import './registerServiceWorker'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import { SpinnerPlugin } from 'bootstrap-vue'
import GAuth from 'vue-google-oauth2'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(SpinnerPlugin)
Vue.use(Vuex)
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
// const gauthOption = {
//     clientId: '1082790608620-4v37efgmqp03uotfaldo9ra44sqt47gp.apps.googleusercontent.com',
//     scope: 'profile email',
//     prompt: 'select_account'
// }
// Vue.use(GAuth, gauthOption)

axios.defaults.baseURL = config.BASE_API_URL
axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.token;
axios.interceptors.response.use(response => {
    return response
}, error => {
    if (error.response.status === 401) {
        store.state.token = null
        router.push({ 'name': 'Login' })
    }
    return error
})

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount("#app");